import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { USER_LISTINGS_BANNED_FROM_BIDDING } from '../../constants/tableTypes'
import { UNBAN_USER_FROM_PROPERTY } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const listingsBannedFromBiddingReducers = (state = initialState, action) => {
  switch (action.type) {
    case UNBAN_USER_FROM_PROPERTY: {
      const content = state.content.filter(
        ({ primary_property: { property_id } }) =>
          property_id !== action.propertyId
      )

      return {
        ...state,
        content,
        fields: state.fields,
        total_elements: content.length,
        isLoading: false,
      }
    }
    default:
      return reducers.dataTable.tableFetchReducer(
        USER_LISTINGS_BANNED_FROM_BIDDING,
        state,
        action
      )
  }
}

export default combineReducers({
  data: listingsBannedFromBiddingReducers,
  tableInfo: tableReducer,
})

export { initialState, listingsBannedFromBiddingReducers }
